import { render, staticRenderFns } from "./CatalogComparison.vue?vue&type=template&id=64afbbd1&scoped=true&"
import script from "./CatalogComparison.vue?vue&type=script&lang=js&"
export * from "./CatalogComparison.vue?vue&type=script&lang=js&"
import style0 from "./CatalogComparison.vue?vue&type=style&index=0&id=64afbbd1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64afbbd1",
  null
  
)

export default component.exports